import { Component, OnInit } from '@angular/core';
import { ChatService } from '../../service/chat-service';
import { Subscription } from 'rxjs';
import { CONFIG } from '../../../app/config/config';
import { CreateDataSource } from '../../model/rolePlay';
import { RoleplayApiService } from '../../service/roleplay.service';
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { InteractionService } from '../../service/interaction/interaction.service';
@Component({
    selector: 'app-create-source',
    templateUrl: './create-source.component.html',
    styleUrl: './create-source.component.scss',
    standalone: false
})
export class CreateSourceComponent implements OnInit {
  selectedOption: string;
  fileExtensions = new FormControl();
  test_version1: boolean;
   CustomizeDetailsSubscription!: Subscription;
   dataSourceArr: Array<string> = [];
   docList = CONFIG.docList; 
  shareId: number;
  sourceName: any;
  selectedFileExtensions: string[] = []; 
  form: FormGroup;
  sourcePath: string = '';
  copy_approved: string = '';
  region: string = '';
  primary_market: string = '';
  product_group: string = '';
  is_internal: string = '';
  decodedUrl: string = '';
  constructor( public ChatService: ChatService, public roleplayservice:  RoleplayApiService,public Router: Router, public dialogRef: MatDialogRef<CreateSourceComponent>,private fb: FormBuilder,private toastr: ToastrService, private readonly intService: InteractionService){
   
  }
  ngOnInit(){
    this.productDataSource();
  }
  productDataSource() {
    this.dataSourceArr = [];
    let business_unit_code = sessionStorage.getItem('businessUnitCode');
    if (business_unit_code !== "") {
      this.ChatService.productDataSource(business_unit_code).subscribe(
        (res) => {
         this.sourceName = res.source_name;
          if (res && res.length > 0) {
            res.map(item => {
              this.dataSourceArr.push(item.source_name);
              this.shareId = item.sharepoint_id;
            });
          } else {
            this.dataSourceArr = [];
          }
        });
    }
  }
  decodeAndShow(): void {
    this.decodedUrl = this.intService.decodeUrl(this.sourcePath); // Decode the sourcePath
  }
  copyToClipboard(): void {
    if (this.decodedUrl) {
      navigator.clipboard.writeText(this.decodedUrl)
        .then(() => {
          this.toastr.success('Decoded URL copied to clipboard!'); // You can show a notification to the user
        })
        .catch(err => {
          console.error('Could not copy text: ', err);
        });
    } else {
      this.toastr.info('Nothing to copy!');
    }
  }
  selectSource(option: string) {
    this.selectedOption = option;
  }
  selectIsInternal(option: string) {
    this.is_internal = option;
  }
  selectCopyApproved(option: string) {
    this.copy_approved = option;
  }
    // To check if a file extension is selected
    isSelected(doc: string): boolean {
      return this.fileExtensions.value && this.fileExtensions.value.includes(doc);
    }
  
    // Method to toggle selection
    toggleSelection(checked: boolean, doc: string) {
      const currentSelection = this.fileExtensions.value || [];
      const selectionIndex = currentSelection.indexOf(doc);
  
      // If the doc is already selected, remove it; otherwise, add it
      if (checked && selectionIndex === -1) {
        currentSelection.push(doc);
      }
      // If unchecked, remove the doc from selection
      else if (!checked && selectionIndex !== -1) {
        currentSelection.splice(selectionIndex, 1);
      }
  
      // Update the form control value
      this.fileExtensions.setValue(currentSelection);
    }
  
  selectFileExt(selectedValues: string[]) {
    this.selectedFileExtensions = selectedValues;
  }
  save(){
    const requiredValues = [
      this.shareId,
      this.sourcePath,
      this.selectedFileExtensions,
      this.selectedOption
    ];
    
    // Check if any value is missing
    const isAnyValueMissing = requiredValues.some(value => !value);

    if (isAnyValueMissing) {
      this.toastr.warning('Please fill in all required fields.'); // Common warning message
      return;
    }
     let sourceData: CreateDataSource = {
            sharepoint_id: this.shareId, 
            source_path: this.sourcePath ,
            // file_ext:  this.selectedFileExtensions ,
           product_name: this.selectedOption,
           copy_approved: this.copy_approved,
           region: this.region,
           primary_market: this.primary_market,
           product_group: this.product_group,
           is_internal: this.is_internal
          }
          this.roleplayservice.submitFileData(sourceData).subscribe(() =>{
            this.toastr.success('Data submitted successfully!'); 
            this.dialogRef.close();
          })
          
  }
  backbutton() {
    this.dialogRef.close();
  }
  
}
